import moment from 'moment';
import {
  GET_ALL_TRIPS,
  DELETE_ONE_TRIP,
  GET_ONE_DEMO_TRIP,
  GET_ONE_TRIP,
  EDIT_TRIP_PARAMS,

  GET_TRIP_EDIT,
  EDIT_TRIP_EDIT,

  GET_TRIP_EDIT_POIS,
  EDIT_TRIP_EDIT_POIS,

  GET_TRIP_EDIT_CITIES,
  EDIT_TRIP_EDIT_CITIES,

  GET_TRIP_MODIFY_POIS,
  EDIT_TRIP_MODIFY_POIS,

  SELECT_TRIP_DAY,
  EDIT_TRIP_PARAMS_CITIES,
  GET_TRIP_PARAMS_CITIES,

  SAVE_TRIP,
  CREATE_TRIP,

  POI_SAVE_TRIP
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE,
  CONTINUE
} from '../../utils/status';
import * as tripService from '../../services/trip';
import * as favoriteService from '../../services/favorite';

// 编辑新建行程的参数
export function editParams(params) {
  return {
    type: EDIT_TRIP_PARAMS,
    data: params
  };
}


// 编辑新建行程的参数（追加城市流程需要）
export function getParamsCities() {
  return function (dispatch, getState) {
    let state = getState();
    let params = state.trip.params;

    dispatch({
      type: GET_TRIP_PARAMS_CITIES,
      data: params
    });

    return Promise.resolve(params);
  };
}
export function editParamsCities(params) {
  return {
    type: EDIT_TRIP_PARAMS_CITIES,
    data: params
  };
}




/**
 * 城市天数分配
 * tripParams 一般包含
 * @param {*} city_day_list
 * @param {*} start_date
 * @param {*} end_data
 */
export function cityDayAssign(tripParams) {
  return function (dispatch, getState) {
    return tripService.cityDayAssign(tripParams)
      .then(function (data) {
        data = getEndDate(data);
        dispatch(editParams(data));

        return data;
      });
  };
}

// 可怕 的要我自己计算结束日期
function getEndDate(data) {
  let { city_day_list, start_date } = data;
  let nights = 0;

  city_day_list.forEach((item)=>{
    if(item.day){
      nights += Number(item.day);
    }
  });

  nights = Math.ceil(nights);
  let endDate = '';
  if(start_date && start_date !== ''){
    endDate = moment(start_date).add(nights, 'days').format('YYYY-MM-DD');
  }

  return { ...data, end_date: endDate };
}

// 获取所有行程
export function getAll() {
  let next_page = arguments[0];

  return function (dispatch) {
    if (!next_page) {
      dispatch({
        type: GET_ALL_TRIPS,
        status: PENDING
      });
    }

    return tripService.getList('')
      .then(function (data) {
        if (data.next_page) {
          dispatch({
            type: GET_ALL_TRIPS,
            status: CONTINUE,
            data: data
          });

          return getAll(data.next_page);
        } else {
          dispatch({
            type: GET_ALL_TRIPS,
            status: SUCCESS,
            data: data
          });

          return data;
        }
      })
      .catch(function (err) {
        dispatch({
          type: GET_ALL_TRIPS,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}



// 删除一个行程
export function deleteOne(id) {
  return function (dispatch) {
    dispatch({
      type: DELETE_ONE_TRIP,
      status: PENDING
    });

    return tripService.deleteOne(id)
      .then(function (id) {
        dispatch({
          type: DELETE_ONE_TRIP,
          status: SUCCESS,
          data: id
        });

        return id;
      })
      .catch(function (err) {
        dispatch({
          type: DELETE_ONE_TRIP,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}

// 获取行程详情
export function getOne(trip_id) {
  return function (dispatch) {
    dispatch({
      type: GET_ONE_TRIP,
      status: PENDING
    });

    return tripService.getOne(trip_id)
      .then(function (trip) {
        dispatch({
          type: GET_ONE_TRIP,
          status: SUCCESS,
          data: trip
        });

        return trip;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ONE_TRIP,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}

// 获取一个Demo行程
export function getOneDemo() {
  return function (dispatch) {
    dispatch({
      type: GET_ONE_DEMO_TRIP,
      status: PENDING
    });

    return tripService.getOneDemo()
      .then(function (trip) {
        dispatch({
          type: GET_ONE_DEMO_TRIP,
          status: SUCCESS,
          data: trip
        });

        return trip;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ONE_DEMO_TRIP,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}



/**
 * 为trip-edit页获取行程state
 *
 * @export
 * @param {any} trip_id
 * @returns
 */
export function getTripEdit(trip_id,itinerary_id) {
  return function (dispatch, getState) {
    let state = getState();
    // 如果“详情页”已经请求了该行程，则直接拿过来用
    if (!itinerary_id && state.trip.detail && state.trip.detail.data === trip_id) {
      let trip = state.entity.trip[trip_id];
      dispatch({
        type: GET_TRIP_EDIT,
        data: trip,
        status: SUCCESS
      });
      return Promise.resolve(trip);
    }

    // 否则从服务器获取
    dispatch({
      type: GET_TRIP_EDIT,
      status: PENDING
    });

    return tripService.getOne(trip_id,itinerary_id)
      .then(function (trip) {
        dispatch({
          type: GET_TRIP_EDIT,
          data: trip,
          status: SUCCESS
        });

        return trip;
      })
      .catch(function (err) {
        dispatch({
          type: GET_TRIP_EDIT,
          data: err,
          status: FAILURE
        });

        throw err;
      });
  };
}

/**
 * 编辑trip-edit页的行程state
 *
 * @export
 * @param {any} trip
 * @returns
 */
export function editTripEdit(trip) {
  return {
    type: EDIT_TRIP_EDIT,
    data: trip
  };
}


/**
 * 为trip-edit-pois页获取行程state
 *
 * @export
 * @param {any} trip_id
 * @returns
 */
export function getTripEditPois(trip_id) {
  return function (dispatch, getState) {
    let state = getState();
    // 根据流程，只能从编辑页传递过来
    let trip = state.trip.editing.tripEdit.data;

    if (trip) {
      dispatch({
        type: GET_TRIP_EDIT_POIS,
        data: trip,
        status: SUCCESS
      });

      return Promise.resolve(trip);
    } else {
      let err = new Error('trip-edit页没能传递数据过来');
      dispatch({
        type: GET_TRIP_EDIT_POIS,
        data: err,
        status: FAILURE
      });

      return Promise.reject(err);
    }
  };
}

/**
 * 编辑trip-edit-pois页的行程state
 *
 * @export
 * @param {any} trip
 * @returns
 */
export function editTripEditPois(trip) {
  return {
    type: EDIT_TRIP_EDIT_POIS,
    data: trip
  };
}

/**
 * 为trip-edit-pois页获取行程state
 *
 * @export
 * @param {any} trip_id
 * @returns
 */
export function getTripEditCities(trip_id) {
  return function (dispatch, getState) {
    let state = getState();
    // 根据流程，只能从编辑页传递过来
    let trip = state.trip.editing.tripEdit.data;

    if (trip) {
      dispatch({
        type: GET_TRIP_EDIT_CITIES,
        data: trip,
        status: SUCCESS
      });

      return Promise.resolve(trip);
    } else {
      let err = new Error('trip-edit页没能传递数据过来');
      dispatch({
        type: GET_TRIP_EDIT_CITIES,
        data: err,
        status: FAILURE
      });

      return Promise.reject(err);
    }
  };
}

/**
 * 编辑trip-edit-cities页的行程state
 *
 * @export
 * @param {any} trip
 * @returns
 */
export function editTripEditCities(trip) {
  return {
    type: EDIT_TRIP_EDIT_CITIES,
    data: trip
  };
}



// 从entity获取行程对象，作为“修改”目标
export function getTripModifyPois(trip_id) {
  return function (dispatch, getState) {
    let state = getState();

    if (trip_id !== state.trip.detail.data) {
      let err = new Error('trip详情页无法传递数据过来');
      dispatch({
        type: GET_TRIP_MODIFY_POIS,
        status: FAILURE,
        err: err
      });

      return Promise.reject(err);
    }

    let trip = state.entity.trip[trip_id];

    dispatch({
      type: GET_TRIP_MODIFY_POIS,
      status: SUCCESS,
      data: trip
    });
  };
}

export function editTripModifyPois(trip) {
  return {
    type: EDIT_TRIP_MODIFY_POIS,
    data: trip
  };
}

export function createOne(params) {
  return function (dispatch) {
    dispatch({
      type: CREATE_TRIP,
      status: PENDING
    });

    return tripService.createOne(params)
      .then(function (trip_id) {
        dispatch({
          type: CREATE_TRIP,
          status: SUCCESS,
          data: trip_id
        });

        return trip_id;
      })
      .catch(function (err) {
        dispatch({
          type: CREATE_TRIP,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}

export function saveOne(trip, itinerary_id) {
  return function (dispatch) {
    dispatch({
      type: SAVE_TRIP,
      status: PENDING
    });

    return tripService.saveOne(trip.trip_id, trip, itinerary_id)
      .then(function () {
      // 更新时间update_time，最终以后端为准
        // trip = {...trip, update_time: (trip.update_time + 1)};
        trip = {...trip, update_time: Math.ceil(new Date().getTime() / 1000)};

        dispatch({
          type: SAVE_TRIP,
          status: SUCCESS,
          data: trip
        });

        return trip;
      })
      .catch(function (err) {
        dispatch({
          type: SAVE_TRIP,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}


/**
 * 选择行程的日期。
 *
 * @export
 * @param {any} day 日期从1开始，0表示全程
 * @returns
 */
export function selectDay(day = 0) {
  day = Number(day);

  return {
    type: SELECT_TRIP_DAY,
    data: day
  };
}

/**
 * 地图poi点直接添加到行程
 */
export function asyncSaveTrip(trip_id, trip, is_publish, isStrict) {
  return favoriteService.fixPoiInfo_trip(trip) // 保存前先做收藏夹数据修正
    .then(trip => {
      console.log(trip);
      return favoriteService.saveTrip(trip_id, trip, is_publish, isStrict)
        .then(function (res) {
          console.log(res);
          return res;
        })
        .catch(function (err) {
          throw err;
        });
    });
}

/**
 * 地图poi点直接添加到行程
 */
// export function asyncSaveTrip(trip_id, trip, is_publish, isStrict) {
//   return function (dispatch) {
//     dispatch({
//       type: POI_SAVE_TRIP,
//       status: PENDING
//     });

//     return favoriteService.fixPoiInfo_trip(trip) // 保存前先做收藏夹数据修正
//       .then(trip => {
//         return favoriteService.saveTrip(trip_id, trip, is_publish, isStrict)
//           .then(function (res) {
//             dispatch({
//               type: POI_SAVE_TRIP,
//               status: SUCCESS
//             });

//             return res;
//           })
//           .catch(function (err) {
//             dispatch({
//               type: POI_SAVE_TRIP,
//               status: FAILURE,
//               data: err
//             });

//             throw err;
//           });
//       });
//   };
// }


// WEBPACK FOOTER //
// ./src/store/actions/trip.js